import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { TwoParticipantsSportsTabState } from './TwoParticipantsSportsTabState';
import { FilterTabs } from 'src/components/Filters/FilterTabs';
import InlineScroll from 'src/components/InlineScroll/InlineScroll.jsx';
import { MarketTemplatesType } from './utilsForMarkets';

interface PropsType {
    sportState: TwoParticipantsSportsTabState;
    footballMarkets?: Array<MarketTemplatesType>;
}

export const MenuScrollFootballMarkets = observer('MenuScrollFootballMarkets', (props: PropsType) => {
    const { sportState, footballMarkets } = props;

    if (sportState.currentSport === 'football') {
        const activeMarket = sportState.currentMarket === null ? 'match-winner' : sportState.currentMarket;
        const markets = footballMarkets ?? [];
        const availableMarkets = markets.map((item) => {
            return { name: item.marketName, id: item.id };
        });

        return (
            <div className='two-participants-events-filter'>
                <InlineScroll>
                    <FilterTabs
                        available={availableMarkets}
                        active={activeMarket}
                        onChange={sportState.changeMarket}
                    />
                </InlineScroll>
            </div>
        );
    }
    return null;
});
